import React from 'react';
import { noop } from 'lodash-es';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Col, Form, Row } from 'reactstrap';
import { MakeDropdown } from 'site-modules/shared/components/vehicle-dropdowns/make-dropdown';
import { ModelDropdown } from 'site-modules/shared/components/vehicle-dropdowns/model-dropdown';
import { ZipInput } from 'site-modules/shared/components/zip-input/zip-input';
import { validation } from 'site-modules/shared/components/form-validation/validation';
import { DEFAULT_PUB_STATES, generateTrackingIds } from 'site-modules/shared/utils/make-model-zip';
import { Select } from 'site-modules/shared/components/inventory/select/select';
import { Button } from 'site-modules/shared/components/inventory/button/button';
import { Input } from 'site-modules/shared/components/inventory/input/input';

import './make-model-zip-dropdown-form.scss';

export function MakeModelZipDropdownForm({
  dataTrackingParent = '',
  onSubmit = noop,
  className,
  hasZipInput = false,
  hasYearDropdown = false,
  make = null,
  setMake,
  pubStates = DEFAULT_PUB_STATES,
  tracking = generateTrackingIds(''),
  model = null,
  setModel,
  makeModelYears = [],
  year = null,
  setYear,
  onZipChangeInProgress = noop,
  isFormDisabled = false,
  rel = '',
}) {
  const getDropdownMdColSize = () => {
    if (hasYearDropdown && hasZipInput) {
      return 3;
    }

    if (hasYearDropdown || hasZipInput) {
      return 4;
    }

    return 6;
  };

  return (
    <Form
      className={classnames('make-model-zip-dropdown-form d-flex flex-wrap align-items-end', className)}
      autoComplete="off"
      onSubmit={onSubmit}
      data-tracking-parent={dataTrackingParent}
    >
      <Row className="make-model-zip-dropdown-form-controls">
        <Col xs={12} md={getDropdownMdColSize()} className="mb-1 mb-md-0">
          <MakeDropdown
            id="make-dropdown"
            value={make && make.slug}
            onChange={setMake}
            pubStates={pubStates}
            data-tracking-id={tracking.makeSelectTrackingId}
            isLabelHidden={false}
            labelClassName="mb-0_5 size-12 text-gray-darker"
            size="lg"
            selectComponent={Select}
            className=""
          />
        </Col>
        <Col xs={12} md={getDropdownMdColSize()} className="mb-1 mb-md-0">
          <ModelDropdown
            id="model-dropdown"
            make={make}
            value={model && model.name}
            preSavedValue={model && model.name}
            onChange={setModel}
            pubStates={pubStates}
            data-tracking-id={tracking.modelSelectTrackingId}
            isLabelHidden={false}
            labelClassName="mb-0_5 size-12 text-gray-darker"
            size="lg"
            selectComponent={Select}
            className=""
          />
        </Col>
        {hasYearDropdown && (
          <Col xs={12} md={getDropdownMdColSize()} className="mb-1 mb-md-0">
            <Select
              id="year-select"
              options={makeModelYears}
              value={year && year.value}
              onChange={setYear}
              name="select-year"
              toggle="Year"
              valueKey="value"
              labelKey="value"
              className="js-years-select w-100"
              data-tracking-id={tracking.yearSelectTrackingId}
              labelText="Year"
              labelClassName="mb-0_5 size-12 text-gray-darker"
              size="lg"
            />
          </Col>
        )}
        {hasZipInput && (
          <Col xs={12} md={getDropdownMdColSize()}>
            <ZipInput
              wrapperClasses="mb-1 mb-md-0"
              inputClasses="form-control make-model-zip-dropdown-form-zip-input location-icon"
              labelClasses="mb-0_5 size-12 text-gray-darker"
              label="ZIP Code"
              onValidate={validation.validateZip}
              getTracking={tracking.zipInputTracking}
              onZipChangeInProgress={onZipChangeInProgress}
              inputComponent={Input}
              inputProps={{
                bsSize: 'lg',
              }}
            />
          </Col>
        )}
      </Row>
      <Button
        type="submit"
        color="blue-50"
        disabled={isFormDisabled}
        rel={rel}
        className="make-model-zip-dropdown-form-submit w-100 px-0 px-md-1_5 fw-medium text-transform-none ms-md-1 size-16"
        data-test="mmz-go-btn"
        data-tracking-id={tracking.submitTrackingId}
      >
        Go
      </Button>
    </Form>
  );
}

MakeModelZipDropdownForm.propTypes = {
  dataTrackingParent: PropTypes.string,
  onSubmit: PropTypes.func,
  className: PropTypes.string,
  hasZipInput: PropTypes.bool,
  hasYearDropdown: PropTypes.bool,
  make: PropTypes.shape({}),
  model: PropTypes.shape({}),
  year: PropTypes.shape({ value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]) }),
  setMake: PropTypes.func.isRequired,
  setModel: PropTypes.func.isRequired,
  pubStates: PropTypes.arrayOf(PropTypes.string),
  tracking: PropTypes.shape({}),
  makeModelYears: PropTypes.arrayOf(
    PropTypes.shape({ value: PropTypes.number, isUsed: PropTypes.bool, isPreprod: PropTypes.bool })
  ),
  setYear: PropTypes.func.isRequired,
  onZipChangeInProgress: PropTypes.func,
  isFormDisabled: PropTypes.bool,
  rel: PropTypes.string,
};
